export const ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  PICKER: 'PICKER',
  // Fresh Inventory module roles. FRESH_STAFF is mobile-app only and holds no
  // admin pages at all; FRESH_REPORT can only be granted the Fresh Reports
  // page. Which pages each may hold is served by the backend
  // (GET /users/allowed-pages), not hardcoded here.
  FRESH_STAFF: 'FRESH_STAFF',
  FRESH_REPORT: 'FRESH_REPORT',
} as const

// Human-friendly labels for the raw role values (used in the users grid, etc.)
export const ROLE_LABELS: Record<string, string> = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.PICKER]: 'Picker',
  [ROLES.FRESH_STAFF]: 'Fresh Staff',
  [ROLES.FRESH_REPORT]: 'Fresh Report',
}

/**
 * Roles that sign in to the Fresh mobile app rather than the admin site.
 * A user on one of these never goes through the approval-manager OTP step, so
 * the Approval Manager field does not apply to them.
 */
export const FRESH_MOBILE_ONLY_ROLES: string[] = [ROLES.FRESH_STAFF]

/**
 * Every role that belongs to the Fresh Inventory module. Used to hide the
 * GrandPOS and SAP settings on the user form - none of them reach a Fresh
 * user, so showing them only invites a meaningless grant.
 */
export const FRESH_ROLES: string[] = [ROLES.FRESH_STAFF, ROLES.FRESH_REPORT]
